<template>
    <footer class="bg-black border-t border-jackpot-bg">
        <div class="container mx-auto relative">
            <div class="mx-2 h-11 flex items-center justify-center gap-1 sm:gap-2 text-gray-900 dark:text-gray-100 pt-1">
                <button @click.prevent="click('games-list-clicked')"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none"
                    :class="state.gamesList || state.gameLobby ? 'footer-button-active' : 'footer-button'">
                    Lobbies
                </button>
                <button @click.prevent="click('global-chat-clicked')"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none relative"
                    :class="state.globalChat ? 'footer-button-active' : 'footer-button'">
                    Chat
                    <div v-if="newMessages"
                        class="bg-red-700 text-red-100 leading-4 rounded-md text-xs px-1 absolute -top-2 -right-1">
                        {{ showNewMessages }}
                    </div>
                </button>
                <button @click.prevent="click('your-games-list-clicked')" :disabled="!authenticated"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none relative disabled:opacity-50"
                    :class="state.yourGamesList || state.game ? 'footer-button-active' : 'footer-button'">
                    Games
                    <div v-if="newGames"
                        class="bg-red-700 text-red-100 leading-4 rounded-md text-xs px-1 absolute -top-2 -right-1">
                        {{ showNewGames }}
                    </div>
                </button>
                <button v-if="!game.show || (game.show && game.status == 'ended')"
                    @click.prevent="click('app-info-clicked')"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none"
                    :class="state.appInfo ? 'footer-button-active' : 'footer-button'">
                    Info
                </button>
                <button v-if="game.show && game.messages.length" @click.prevent="click('show-log')"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none relative disabled:opacity-25">
                    Log
                </button>
                <button v-if="isTeamWallet && false" @click.prevent="click('game-config-clicked')"
                    class="flex-1 footer-button p-1 rounded sm:w-20 text-center text-sm uppercase select-none relative disabled:opacity-25"
                    :class="state.gameConfig ? 'footer-button-active' : 'footer-button'">
                    Config
                </button>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterMenu',
    props: ['state', 'newMessages', 'newGames', 'authenticated', 'game', 'isTeamWallet'],
    computed: {
        showNewGames() {
            return this.newGames > 99 ? '...' : this.newGames
        },
        showNewMessages() {
            return this.newMessages > 99 ? '...' : this.newMessages
        }
    },
    methods: {
        click(event) {
            this.emitter.emit(event)
        }
    }
}
</script>
